module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    attrs: {
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择日期范围"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "alue-format": "yyyy-MM-dd",
      "align": "right",
      "unlink-panels": "",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "picker-options": _vm.pickerOptions,
      "value-format": "yyyy-MM-dd"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.vdate),
      callback: function($$v) {
        _vm.vdate = $$v
      },
      expression: "vdate"
    }
  })], 1), _vm._v(" "), (_vm.is_distributor === false) ? _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_vm._v("\n         \n         "), _c('el-select', {
    attrs: {
      "placeholder": "请选择门店",
      "filterable": ""
    },
    on: {
      "change": _vm.DistributorChange
    },
    model: {
      value: (_vm.params.distributor),
      callback: function($$v) {
        _vm.$set(_vm.params, "distributor", $$v)
      },
      expression: "params.distributor"
    }
  }, _vm._l((_vm.distributorOption), function(item) {
    return _c('el-option', {
      key: item.distributor_id,
      attrs: {
        "label": item.name,
        "size": "mini",
        "value": item.distributor_id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.getDistributorDataList(true)
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "warning",
      "size": "mini"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")])], 1)], 1)], 1), _vm._v(" "), (_vm.$route.path.indexOf('_editor') === -1) ? _c('el-tabs', {
    attrs: {
      "type": "border-card"
    },
    on: {
      "tab-click": _vm.handleClick
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "会员数",
      "name": "member"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "canvas_member",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "售后单数",
      "name": "aftersales"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "canvas_aftersales",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "退款额",
      "name": "refunded"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "canvas_refunded",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "交易额",
      "name": "amountPayed"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "canvas_amountPayed",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "交易额(积分)",
      "name": "amountPointPayed"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "canvas_amountPointPayed",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "订单数",
      "name": "order"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "canvas_order",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "订单数(积分)",
      "name": "orderPoint"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "canvas_orderPoint",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "付款订单数",
      "name": "orderPayed"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "canvas_orderPayed",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "付款订单数(积分)",
      "name": "orderPointPayed"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "canvas_orderPointPayed",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "GMV",
      "name": "gmv"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "canvas_gmv",
      "height": "120"
    }
  })])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "GMV(积分)",
      "name": "gmvPoint"
    }
  }, [_c('section', [_c('canvas', {
    attrs: {
      "id": "canvas_gmvPoint",
      "height": "120"
    }
  })])])], 1) : _vm._e(), _vm._v(" "), [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.allListData,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "count_date",
      "label": "日期",
      "fixed": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "member_count",
      "label": "会员数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "aftersales_count",
      "label": "售后单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "退款额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.refunded_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount_payed_count",
      "label": "交易额"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.amount_payed_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "amount_point_payed_count",
      "label": "交易额(积分)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_count",
      "label": "订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_point_count",
      "label": "订单数(积分)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_payed_count",
      "label": "付款订单数"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_point_payed_count",
      "label": "付款订单数(积分)"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gmv_count",
      "label": "GMV"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("￥" + _vm._s(scope.row.gmv_count / 100))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gmv_point_count",
      "label": "GMV(积分)"
    }
  })], 1)]], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-65908e4e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65908e4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/datacube/distributordata.vue
// module id = 2784
// module chunks = 0